import { ScrollArea } from "@mantine/core";
import type { ReferralInfo, ReferralStatus } from "@src/gql/graphql";
import { getReferralStatusMeta, getRegisteredDateText } from "../helpers";

function ReferralStatusBadge({ status }: { status: ReferralStatus }) {
	const { label, className } = getReferralStatusMeta(status);

	return (
		<span
			className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${className}`}
		>
			{label}
		</span>
	);
}

export function ReferralTable({
	referralUsers,
}: { referralUsers: ReferralInfo[] }) {
	return (
		<ScrollArea
			h={250}
			classNames={{
				scrollbar: "custom-scrollbar",
			}}
		>
			<div className="flex flex-col">
				{referralUsers.map((referralUser, index) => (
					<div
						key={`${referralUser.refereeEmail}-${index}`}
						className="grid grid-cols-[1fr_auto] gap-4 px-4 py-3 border-b border-border-subtle last:border-b-0"
					>
						<div className="min-w-0">
							<div className="text-xs text-text-primary truncate">
								{referralUser.refereeEmail}
							</div>
							<div className="mt-1">
								<ReferralStatusBadge status={referralUser.status} />
							</div>
						</div>
						{referralUser.registeredAt && (
							<div className="text-xs text-text-primary whitespace-nowrap text-right">
								{getRegisteredDateText(referralUser.registeredAt)}
							</div>
						)}
					</div>
				))}
			</div>
		</ScrollArea>
	);
}
